import { ComponentHandler } from 'src/app/services/component-services/component-handler';
import { GtinCheckService } from './../../../../services/component-services/gtin-check-service';
import { AuthService } from './../../../../services/auth-service';
import { ColorThemeService } from './../../../../navigation/services/color-theme-service';
import { PackagingComponentTypesEnum } from './../../../../model/packaging-component-types-enum';
import { DictionaryHandler } from './../../../../model/dictionary';
import { ComponentTypeService } from './../../../../navigation/services/component-type-service';
import { ComponentApiService } from '../../../../data-transfer/services/component-api-service';
import { ComponentCreateUpdateParentComponent } from './../common/component-create-update-parent/component-create-update-parent.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, HostListener } from '@angular/core';
import { Observable } from 'rxjs';
import { ComponentNavigationService } from 'src/app/navigation/services/navigation-services/component-navigation-service';
import { ComponentCanDeactivate } from 'src/app/services/unsaved-changes-guard';
import { FileApiService } from 'src/app/data-transfer/services/file-api-service';
import { COLOR_THEME_DARK } from 'src/app/navigation/services/color-theme-service';
import { VersionDto } from 'src/app/data-transfer/entities/version-dto';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { DecorationDto } from 'src/app/data-transfer/entities/component-entities/decoration-dto';
import { DataExchangeRequestApiService } from 'src/app/data-transfer/services/data-exchange-request-api-service';
import { PathResolveService } from 'src/app/services/path-resolve.service';
import { DirectoryApiService } from 'src/app/data-transfer/services/directory-api-service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-create-update-decoration',
  templateUrl: './create-update-decoration.component.html',
  styleUrls: ['./create-update-decoration.component.scss']
})
export class CreateUpdateDecorationComponent extends ComponentCreateUpdateParentComponent
  implements OnInit, ComponentCanDeactivate {

  decoration!: DecorationDto;
  packagingComponentType = PackagingComponentTypesEnum;

  constructor(
    protected componentHandler: ComponentHandler,
    protected dialog: MatDialog,
    protected spinner: NgxSpinnerService,
    protected componentApiService: ComponentApiService,
    protected navigationService: ComponentNavigationService,
    protected componentTypeService: ComponentTypeService,
    protected dictionaryHandler: DictionaryHandler,
    protected fileApiService: FileApiService,
    protected authService: AuthService,
    protected gtinCheckService: GtinCheckService,
    protected dataExchangeApiService: DataExchangeRequestApiService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected directoryApiService: DirectoryApiService,
    protected translocoService: TranslocoService,
    private formBuilder: FormBuilder,
    private colorThemeService: ColorThemeService,
  ) {
    super(componentHandler, dialog, spinner, componentApiService, navigationService,
      componentTypeService, dictionaryHandler, fileApiService, authService, gtinCheckService,
      dataExchangeApiService, route, router, directoryApiService, translocoService);
  }

  ngOnInit(): void {
    this.callerId = PackagingComponentTypesEnum.Decoration;
    this.componentSubtypes = this.componentHandler.getComponentSubtypesSelection(this.callerId);

    this.routeDataSubscription = this.route.data.subscribe(data => {
      if (data.component) {
        this.decoration = data.component;
        this.historyVersions = [{
          id: data.component.id,
          versionNumber: data.component.version,
          versionName: data.component.versionName,
          creationTimestamp: data.component.creationTimestamp,
          isCurrentVersion: data.component.isCurrentVersion,
          packagingComponentCategoryId: this.callerId
        }];
        this.currentDirectoryId = data.component.directoryId;
        if (this.form) {
          window.location.reload();
          super.initComponent(this.decoration, this.route);
        }
        this.componentType = this.componentTypeService.getDecorationTypeDtoBySubtypeId(
          this.decoration?.packagingComponentSubtypeId ?? -1);
      } else if (data.dataExchangeRequest) {
        this.decoration = data.dataExchangeRequest.component;
        this.subRequestInfo = data.dataExchangeRequest.subRequestInfo;
        this.historyVersions = [{
          id: data.dataExchangeRequest.component.id,
          versionNumber: data.dataExchangeRequest.component.version,
          versionName: data.dataExchangeRequest.component.versionName,
          creationTimestamp: data.dataExchangeRequest.component.creationTimestamp,
          isCurrentVersion: data.dataExchangeRequest.component.isCurrentVersion,
          packagingComponentCategoryId: this.callerId
        }];
        this.currentDirectoryId = data.dataExchangeRequest.component.directoryId;
        if (this.form) {
          window.location.reload();
          super.initComponent(this.decoration, this.route);
        }
        this.componentType = this.componentTypeService.getDecorationTypeDtoBySubtypeId(
          this.decoration?.packagingComponentSubtypeId ?? -1);
      } else {
        this.decoration = new DecorationDto();
        this.decoration.images = [];
        this.decoration.certificates = [];
        this.decoration.documents = [];
      }

      this.isInternallyTracked = data.dataExchangeRequest?.isInternallyTracked ?? data.isInternallyTracked;

      if (data.permissions) {
        this.permissions = data.permissions;
      }
      if (data.isDataExchangeSubRequest) {
        this.isDataExchangeSubRequest = true;
        if (!data.permissions) {
          super.fetchComponentPermissions(this.decoration);
        }
      }
      if (data.isInOngoingDataExchange) {
        this.isInOngoingDataExchange = data.isInOngoingDataExchange;
        if (this.isInOngoingDataExchange.length > 0 && this.decoration.isCurrentVersion) {
          super.navigateToFirstOngoingExchange(this.decoration.id);
          return;
        }
      }
    });

    super.initComponent(this.decoration, this.route);
    const decorationComponent = this.componentHandler.components[this.callerId];
    this.form = decorationComponent.createBaseForm(this.decoration, this.formBuilder, this.componentSubtypes, this.isTracked);
    // disable for data exchange sub request because it would create a new entity instead of updating the existing one
    if (this.isDataExchangeSubRequest && this.subRequestInfo?.isReceiver && this.form.getRawValue().packagingComponentSubtypeId != null) {
      this.form.controls.packagingComponentSubtypeId.disable();
    }
    this.form.controls.isRigidComponent.clearValidators();
    this.form = this.formBuilder.group({
      ...this.form.controls,
      distributionCountries: [this.decoration.distributionCountries],
      printingCoverage: [this.decoration.printingCoverage != null ? this.decoration.printingCoverage * 100 : null,
      [Validators.min(0), Validators.max(100)]]
    });
    this.form.controls.totalWeight.disable();
    super.initGtinCheck();

    this.setUpLockAndHeartbeat(this.decoration);
    this.disableFormIfRequired();

    this.themeSubscription = this.colorThemeService.colorThemeSubject.subscribe((nextValue) => {
      this.isDarkTheme = nextValue === COLOR_THEME_DARK;
      this.imageSource = this.componentTypeService.getComponentTypeImage(this.callerId, this.isDarkTheme);
    });
  }

  onDecorationTypeChanged(decorationSubTypeId: number) {
    this.componentType = this.componentTypeService.getDecorationTypeDtoBySubtypeId(decorationSubTypeId);
  }

  async onComponentSubmit(materialEdited: boolean) {
    this.materialEdited = materialEdited;
    this.form.markAllAsTouched();
    const decorationComponent = this.componentHandler.components[this.callerId];
    this.decoration = decorationComponent.getSingleComponentFromForm(this.form.getRawValue(), false, this.decoration);
    super.onSubmit(this.decoration);
  }

  async onFinishSubRequest(materialEdited: boolean) {
    if (!super.isFormValidForSubRequest()) { return; }
    this.materialEdited = materialEdited;
    this.form.markAllAsTouched();
    const decorationComponent = this.componentHandler.components[this.callerId];
    this.decoration = decorationComponent.getSingleComponentFromForm(this.form.getRawValue(), false, this.decoration);
    const subRequestId = +this.route.snapshot.params['id'];
    const subtypeId = this.decoration.packagingComponentSubtypeId;
    let updateFn: (id: number, dto: DecorationDto, submit?: boolean, stayOnPage?: boolean) => Observable<void>;
    if (this.componentTypeService.isDecorationOfTypeLabel(subtypeId)) {
      updateFn = (id, dto, submit, stayOnPage) => this.dataExchangeApiService.updateSubRequestLabel(id, dto, submit, stayOnPage);
    } else if (this.componentTypeService.isDecorationOfTypeSleeve(subtypeId)) {
      updateFn = (id, dto, submit, stayOnPage) => this.dataExchangeApiService.updateSubRequestSleeve(id, dto, submit, stayOnPage);
    } else {
      updateFn = (id, dto, submit, stayOnPage) => this.dataExchangeApiService.updateSubRequestInMoldLabel(id, dto, submit, stayOnPage);
    }
    super.setDataAndUpdateAsSubRequest(
      this.decoration,
      subRequestId,
      updateFn,
      () => super.onSubRequestFinished()
    );
  }

  changeDecorationVersionName(event: { historyVersion: VersionDto, newName: string }) {
    super.changeVersionName(event.historyVersion, event.newName, this.decoration);
  }

  async releaseComponent() {
    super.releaseComponent(this.decoration);
  }

  @HostListener('window:beforeunload')
  canDeactivate(): boolean {
    return (this.form?.pristine && !this.filesEdited) || this.isPreview || this.isUserValidator || this.isUserAdmin || this.isHistory;
  }
}
